<template>
  <div
    :class="{
      'main-container':
        !isLanding(LandingTypes.RESERVATIONS) && !isLanding(LandingTypes.DESTINATION),
      'main-container--gray': isLanding(LandingTypes.ACCOUNTNLP),
      'main-container--light-grey': isLanding(LandingTypes.RHGINSTRUCTIONSMAP),
      'main-container--destination': isLanding(LandingTypes.DESTINATIONCOUNTRYCITY),
      'rhg-col-12': isLanding(LandingTypes.DESTINATION)
    }"
    :style="{
      'background-color':
        isLanding(LandingTypes.ACCOUNTNLP) ||
        isLanding(LandingTypes.PROFILE) ||
        isLanding(LandingTypes.MANAGE_MEMBERS) ||
        isLanding(LandingTypes.STATEMENTSNLP)
          ? '#EEEEf1'
          : ''
    }"
  >
    <Destination v-if="isLanding(LandingTypes.DESTINATION)" />
    <DestinationCountryCity v-if="isLanding(LandingTypes.DESTINATIONCOUNTRYCITY)" />
    <Landing
      v-if="labelsLoaded && isLanding(LandingTypes.GENERAL)"
      :landingOffers="isLanding(LandingTypes.OFFERS)"
    />

    <template v-else-if="labelsLoaded && isLanding(LandingTypes.OFFERS)">
      <OffersRevamp :landingOffers="isLanding(LandingTypes.OFFERS)" />
    </template>
    <directory v-else-if="labelsLoaded && isLanding(LandingTypes.DIRECTORY)" />
    <MyAccount
      :is-travel-agent="isTravelAgent"
      v-else-if="labelsLoaded && isLanding(LandingTypes.ACCOUNT)"
    />
    <RegisteredOffersView v-else-if="labelsLoaded && isLanding(LandingTypes.REGISTERED_OFFERS)" />
    <NlpMyAccount
      v-else-if="labelsLoaded && loggedUser && isLanding(LandingTypes.ACCOUNTNLP)"
      :isB2BUser="isB2B"
    />
    <SignUpB2C
      v-else-if="transliterableLanguagesLoaded && labelsLoaded && isLanding(LandingTypes.SIGNUPB2C)"
      :isChina="isChina"
    />
    <SignUpB2B
      v-else-if="transliterableLanguagesLoaded && labelsLoaded && isLanding(LandingTypes.SIGNUPB2B)"
      :isChina="isChina"
    />
    <template v-else-if="labelsLoaded && isLanding(LandingTypes.PROFILE)">
      <NlpMyProfile />
    </template>
    <PointTransfer
      v-else-if="labelsLoaded && isLanding(LandingTypes.POINTTRANSFER) && loggedUser"
    />
    <PointTransferSummary
      :isChina="isChina"
      v-else-if="labelsLoaded && isLanding(LandingTypes.POINTTRANSFERSUMMARY)"
    />
    <PointTransferConfirmation
      v-else-if="labelsLoaded && isLanding(LandingTypes.POINTTRANSFERCONFIRMATION)"
    />
    <MultiOffers v-else-if="labelsLoaded && isLanding(LandingTypes.MULTIOFFERS)" />
    <NlpMyStatements v-else-if="labelsLoaded && isLanding(LandingTypes.STATEMENTSNLP)" />
    <PortalTarget name="modal-root-dates" />
    <PortalTarget name="modal-root-location" />
    <InteractiveMapView v-if="labelsLoaded && isLanding(LandingTypes.INTERACTIVEMAP)" />
    <MyPromocodesPage v-if="isLanding(LandingTypes.PROMOCODES)" />
    <MyReservations
      v-if="isReservationsSetted && labelsLoaded && isLanding(LandingTypes.RESERVATIONS)"
      :isB2B="isB2B || isNewCorporateProgramActive"
    />
    <DiscoveryPage v-if="labelsLoaded && isLanding(LandingTypes.DISCOVERY)" />
    <ReservationsSummary
      v-if="labelsLoaded && isLanding(LandingTypes.RESERVATION_SUMMARY)"
      :isLogged="loggedUser"
    />
    <ManageMembers
      v-if="labelsLoaded && loggedUser && isLanding(LandingTypes.MANAGE_MEMBERS)"
      :isLogged="loggedUser"
    />
    <InstructionsMapView
      v-if="isLanding(LandingTypes.RHGINSTRUCTIONSMAP)"
      :labelsLoaded="labelsLoaded"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { LandingTypes, isChina, ProgramTypes } from '@/infrastructure/Configuration'
import AuthService from '@/services/AuthService'
import MultiOffers from '@/views/MultiOffers'

export default {
  name: 'app',
  components: {
    MultiOffers,
    OffersRevamp: () => import('@/views/OffersRevamp'),
    Landing: () => import('@/views/Landing'),
    Directory: () => import('@/views/Directory'),
    NlpMyProfile: () => import('@/views/NlpMyProfile'),
    MyAccount: () => import('@/views/MyAccount'),
    RegisteredOffersView: () => import('@/views/RegisteredOffersView'),
    SignUpB2C: () => import('@/views/SignUpB2C'),
    PointTransfer: () => import('@/views/PointTransfer'),
    PointTransferSummary: () => import('@/views/PointTransferSummary'),
    PointTransferConfirmation: () => import('@/views/PointTransferConfirmation'),
    SignUpB2B: () => import('@/views/SignUpB2B'),
    NlpMyAccount: () => import('@/views/NlpMyAccount'),
    InteractiveMapView: () => import('@/views/InteractiveMapView'),
    MyPromocodesPage: () => import('@/views/MyPromocodesPage'),
    MyReservations: () => import('@/views/MyReservations'),
    DiscoveryPage: () => import('@/views/Discovery'),
    ReservationsSummary: () => import('@/views/ReservationsSummary'),
    ManageMembers: () => import('@/views/ManageMembers'),
    NlpMyStatements: () => import('@/views/NlpMyStatements'),
    InstructionsMapView: () => import('@/views/InstructionsMapView'),
    Destination: () => import('@/views/Destination'),
    DestinationCountryCity: () => import('@/views/DestinationCountryCity')
  },
  computed: {
    ...mapGetters(['isNewCorporateProgramActive']),
    ...mapState(['landingType', 'labelsLoaded', 'transliterableLanguagesLoaded'])
  },
  mounted() {
    this.isChina = isChina
  },
  methods: {
    isLanding(view) {
      return this.landingType === view
    }
  },
  async created() {
    try {
      await this.$store.dispatch('getLabels')
      await this.$store.dispatch('getTransliteratableLanguages')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }

    if (global.AuthDispatcher.currentCustomer) {
      await this.$store.dispatch('setCustomer', global.AuthDispatcher.currentCustomer)
      this.isB2B = global.AuthDispatcher.currentCustomer.programType === ProgramTypes.B2B
      this.isReservationsSetted = true
      this.loggedUser = true
    }
    AuthService.onLogged(async data => {
      this.isTravelAgent = data.isTravelAgent
      this.isB2B = data.programType === ProgramTypes.B2B
      this.isReservationsSetted = true
      await this.$store.dispatch('setCustomer', data)
      this.loggedUser = true
    })
  },
  data: () => ({
    LandingTypes,
    isTravelAgent: false,
    isB2B: false,
    isReservationsSetted: false,
    isChina: false,
    loggedUser: false,
    userMemberType: false
  })
}
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
  min-height: 800px;

  &--gray {
    background-color: color('grey-soft-two');
  }

  &--light-grey {
    background-color: color('light-grey');
  }

  &--destination {
    min-height: fit-content !important;
    width: 100%;
    max-width: 1344px;
  }
}
</style>
